export default __webpack_public_path__ + "static/media/0082.666c5610.jpg";